import {
  PhotographUser,
  SubscriptionPlan,
  BookingSettingsType,
  BookingAvailabilityAttr,
  BookingAvailabilityType,
} from 'src/types/user';

export const PhotographMapper = (user: PhotographUser) => {
  const mappedUser: any = {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    password: user.password,
    contact_phone: user.phone,
    phone_verification: user.phone_verification,
    timezone: user.timezone,
    category: user.category, // Uncommented category field
    ref: user.ref,
    account_invite: user.account_invite,
    // Company Information
    company_name: user.company_name,
    company_industry: user.company_industry,
    company_website: user.company_website,
    company_address: user.company_address,
    // Address Information
    street_address_1: user.street_address_1,
    street_address_2: user.street_address_2,
    locality: user.locality,
    state: user.state,
    zip: user.zip,
    country_code: user.country_code,
    // Profile Information
    bio: user.bio,
  };

  // If plan_id is provided, add subscription_plan object
  if (user.plan_id) {
    mappedUser.subscription_plan = {
      id: user.plan_id,
      success_url: `${window.location.origin}/channels`,
      cancel_url: `${window.location.origin}/choose-your-plan`
    };
  }

  return mappedUser;
};

// Return an object with days as key and their information
// {
//  'monday': {
//      'start': '1'
//      'end': '1'
//      'enabled': true
//  }
// }
export const bookingAvailabilitySerializer = (items) => {
  if (items.length === 0) return {};

  return items.reduce((acc, item) => {
    return { ...acc, [item.day]: { ...item } };
  }, {});
};

export const bookingAvailabilityMapper = (items): BookingAvailabilityType => {
  const bookingAvailability = Object.keys(items).reduce((acc, objKey) => {
    if (items[objKey].start_time !== '') {
      acc.push({ ...items[objKey] });
    }
    return acc;
  }, []);

  const data: BookingAvailabilityType = {
    booking_availabilities_attributes:
      bookingAvailability as BookingAvailabilityAttr[],
  };

  return data;
};

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const getBookingAvailabilityEmptyState = () => {
  const weekSchedule = weekDays.reduce((acc, curr) => {
    acc[curr] = { start_time: '', end_time: '', day: curr, enabled: false };
    return acc;
  }, {});

  return {
    ...weekSchedule,
    lead_time: 24,
    appointment_buffer: 0
  };
};
